module.exports = __webpack_public_path__ + "static/media/filter-results-button.52a2f446.svg";